import { ErrorColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      backgroundColor: ErrorColors.base.default,
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s20,
      textAlign: 'center',
      padding: [Spacings.s24, Spacings.s0],
    },
  }),
  {
    name: 'warning-component',
  },
);

export default useStyles;
